export class OrderStudyDeclineReqModel {
  OrderId: number;
  empId: number;
  orgId: number;
}
